import angular from 'angular';
import uiRouter from 'angular-ui-router';
import mainComponent from './main.component';

let mainModule = angular.module('main', [
  uiRouter
])

.component('main', mainComponent)
.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  //$urlRouterProvider.otherwise('/');

  $stateProvider
    .state('main', {
      url: '',
      component: 'main',
      data: {protected: true}
    });
})
.name;

export default mainModule;



// WEBPACK FOOTER //
// ./client/app/components/main/main.js